import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import ScreenDisplayer, { ScreenDisplayerListener } from './../view/box-utils/ScreenDisplayer.react.js';
import {wrapNotFound} from '../app/NotFoundHandler.react';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

interface DataViewProps {
    relay: object;
    user: User;
}

class DataView extends React.Component<DataViewProps> {

    typeName = 'dataSets';

    static propTypes = {
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const data = this.props.user.organisation.channel.dataSet;
        let type = types[this.typeName];

        let content = {
            layout: 'list',
            views: data.viewWithData && data.viewWithData.edges ? data.viewWithData.edges.map(({node: viewWithData}) => viewWithData.view['realId']) : []
        };

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={data.entityDef.name}>
                <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                    <h2><div style={{display: "inline-block", marginRight: ".5em"}}><ChannelIcon channelDef={data.channelDef} size={64}/></div> {data.entityDef.name}</h2>

                    <TableDetail columns={['sourceDef.name']} data={data} metadata={type} />

                    <div className="row">
                        <ScreenDisplayer
                            content={content}
                            listener={new ScreenDisplayerListener()}
                            relay={this.props.relay}
                            viewsWithData={this.props.user.organisation.channel.dataSet.viewWithData.edges.map(({node}) => node)} />
                    </div>

                </DetailBox>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(DataView, (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.dataSet;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        dataSetId: '',
        keyId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            name,
                        },
                        dataSet(id: $dataSetId) {
                            channelDef_id,
                            channelDef {
                                id,
                                name,
                                icon
                            },
                            channel_id,
                            channelEntityDef_id,
                            entityDef_id,
                            sourceDef_id,
                            organisation_id,
                            id,
                            channel {
                                id,
                                name,
                            },
                            entityDef {
                                id,
                                name,
                            },
                            sourceDef {
                                id,
                                name,
                            },
                            viewWithData(key: $keyId, first: 1) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        view {
                                            id,
                                            template,
                                            handler,
                                            entityViewDef {
                                                id,
                                                template,
                                                title,
                                                handler,
                                                entityDef {
                                                    id,
                                                }
                                            }
                                        },
                                        entityDef {
                                            id,
                                            key,
                                            name,
                                            allFieldDefs(first: 200) {
                                                edges {
                                                    node {
                                                        id,
                                                        realId,
                                                        name,
                                                        description,
                                                        type,
                                                    }
                                                }
                                            }
                                        },
                                        data,
                                        addon,
                                        error,
                                        relations(first: 100) {
                                            edges {
                                                node {
                                                    id,
                                                    realId,
                                                    view {
                                                        id,
                                                        handler,
                                                        entityViewDef {
                                                            id,
                                                            template,
                                                            title,
                                                            handler,
                                                            entityDef {
                                                                id,
                                                            }
                                                        }
                                                    },
                                                    entityDef {
                                                        id,
                                                        key,
                                                        name,
                                                        allFieldDefs(first: 200) {
                                                            edges {
                                                                node {
                                                                    id,
                                                                    realId,
                                                                    name,
                                                                    description,
                                                                    type,
                                                                }
                                                            }
                                                        }
                                                    }
                                                    data,
                                                    addon,
                                                    error,
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
});
